<div class="">
  <div class="form-group my-1">
    <label for="token">{{'Select Desk No.' | translate | async}}</label>
    <select class="form-control" (change)="changeDesk($event)" [(ngModel)]="tokenDesk">
      <option value="0">--Select--</option>
      @for (desk of deskName; track desk) {
        <option [value]="desk.id" [class.font-weight-bold]="desk.desk_status === 'Active'" [class.text-primary]="desk.desk_status === 'Active'">{{ desk.desk_name }}
        </option>
      }
    </select>
  </div>
  @if (queueList) {
    <div class="my-1 py-3 bg-secondary text-center rounded">
      {{'Served' | translate | async}}: {{queueList.total_served }} | {{'No Show' | translate | async}}: {{queueList.total_no_show}}
    </div>
  }
  @if (!queueList) {
    <div class="my-1 py-3 bg-secondary text-center rounded">
      {{'Served: --- | No Show: ---' | translate | async}}
    </div>
  }
  @if (showDetails) {
    <div>
      <div class="border"></div>
      <div class="my-1 py-1 bg-secondary text-center rounded">
        <div class="font-size-serving">{{'Now Serving' | translate | async}}</div>
        @if (servingToken) {
          <div class="font-size-token">{{servingToken}}</div>
        }
        @if (!servingToken) {
          <div class="font-size-token"> --- </div>
        }
      </div>
      <div class="border"></div>
      @if (!is_token_qms) {
        <div class="text-center ">
          @if (pendingToken) {
            <div class="btn-group my-1 w-100" role="group" aria-label="Button">
              @if (!checkCurrentDeskStatus()) {
                <button type="button" class="primary-btn mr-1 w-100" (click)="callNext()" [disabled]="disabledStop">{{'Call Next' | translate |async}}</button>
              }
              @if (!checkCurrentDeskStatus()) {
                <button type="button" class="secondary-btn w-100" (click)="noShow()" [disabled]="disabledStop">{{'No Show' | translate | async}}</button>
              }
            </div>
          }
        </div>
      }
      <div class="border"></div>
      <div class="text-center my-1">
        @if (is_token_qms && !is_last_token) {
          <span>
            @if (!checkCurrentDeskStatus()) {
              <button class="w-100 btn btn-secondary mb-1"  (click)="noShowQms(servingToken,this.queueList)" [title]="title"> {{'No Show' | translate | async}} <img src="assets/images/no_show.svg" width="26" height="26" alt=""></button>
            }
          </span>
        }
        @if (is_token_qms && is_last_token) {
          <span>
            @if (!checkCurrentDeskStatus()) {
              <button class="w-100 btn btn-success mb-1"  (click)="completedQms(servingToken,this.queueList)"> {{'Completed' | translate | async}} <i class="fa fa-check" style="font-size:16px" aria-hidden="true"></i></button>
            }
          </span>
        }
        <button class="w-100 btn btn-danger" (click)="stop()" [disabled]="disabledStop">{{'Stop' | translate | async}} <i class="fa fa-power-off text-white" aria-hidden="true"></i></button>
      </div>
      <div class="border"></div>
      <div class="my-1">
        @if (pendingToken) {
          <table class="table float-left table-size table-responsive-sm">
            <thead>
              <th>{{'Assigned' | translate | async}} <i class="fa fa-refresh float-right text-white" [ngClass]="spin?'fa-spin':''"
              (click)="updateRow()"></i>
            </th>
          </thead>
          @if (pendingToken.length > 0) {
            <tbody>
              @for (d of pendingToken; track d) {
                <tr>
                  <td>{{d.token}}
                    @if (is_token_qms) {
                      <span>
                        @if (!checkCurrentDeskStatus()) {
                          <button class="btn btn-success float-right call-next-button"  (click)="callNextQms(d)" [title]="call"><img  class ="call-next-icon" src="assets/images/call-next.svg" ></button>
                        } </span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (pendingToken.length == 0) {
              <tbody>
                <tr>
                  <td>{{'No Token Found' | translate | async}}</td>
                </tr>
              </tbody>
            }
          </table>
        }
        @if (noShowTokens) {
          <table class="table float-right table-size">
            <thead>
              <th>{{'No Show Tokens' | translate | async}}</th>
            </thead>
            @if (noShowTokens.length > 0) {
              <tbody [ngClass]="noShowTokens.length > 5?'scroll-body-table':''">
                @for (noshow of noShowTokens; track noshow) {
                  <tr>
                    <td>{{noshow.token}}
                      @if (is_token_qms) {
                        <span>
                          <button class="btn btn-primary float-right call-next-button"  (click)="recallQms(noshow)" [title]="recallToken"><img class="call-next-icon" src="assets/images/recall.svg" ></button>
                        </span>
                      }
                      @if (!is_token_qms) {
                        <span>
                          <button class="secondary-btn btn-sm float-right" style="padding: 3px 12px 3px 12px !important; font-size: 11px !important;" (click)="recall(noshow)">Recall</button>
                        </span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (noShowTokens.length == 0) {
              <tbody>
                <tr>
                  <td>{{'No Token Found' | translate | async}}</td>
                </tr>
              </tbody>
            }
          </table>
        }
      </div>
    </div>
  }
  @if (!showDetails) {
    <div class="text-center">
      <button class="btn btn-success w-100" (click)="start()" [disabled]="disabledBtn">{{'field.label.start' | translate | async }}<i
      class="fa fa-power-off text-white" aria-hidden="true"></i></button>
    </div>
  }
</div>